import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=ffed6770&scoped=true&"
import script from "./OrderEdit.vue?vue&type=script&lang=ts&"
export * from "./OrderEdit.vue?vue&type=script&lang=ts&"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=ffed6770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffed6770",
  null
  
)

export default component.exports